/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // ── CRNCY accessibility: polite screen-reader announcer ───────────────────
  // Speaks price changes and validation messages to assistive tech without
  // any visual change. One shared visually-hidden live region for the page.
  var _crncyLiveRegion = null;
  var _crncyLastAnnounced = '';
  var _crncyAnnounceTimer = null;
  function crncyGetLiveRegion() {
    if (_crncyLiveRegion) return _crncyLiveRegion;
    var r = document.getElementById('crncy-a11y-live');
    if (!r) {
      r = document.createElement('div');
      r.id = 'crncy-a11y-live';
      r.setAttribute('role', 'status');
      r.setAttribute('aria-live', 'polite');
      r.setAttribute('aria-atomic', 'true');
      r.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0;';
      document.body.appendChild(r);
    }
    _crncyLiveRegion = r;
    return r;
  }
  function crncyAnnounce(msg) {
    if (!msg || msg === _crncyLastAnnounced) return;
    _crncyLastAnnounced = msg;
    clearTimeout(_crncyAnnounceTimer);
    // Debounce so rapid typing doesn't flood the screen reader.
    _crncyAnnounceTimer = setTimeout(function() {
      var r = crncyGetLiveRegion();
      r.textContent = '';
      setTimeout(function() { r.textContent = msg; }, 30);
    }, 500);
  }

  // ── Packaging add button ──────────────────────────────────────────────────
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-packaging-add]');
    if (!btn) return;
    e.preventDefault();
    const VARIANT_ID = 44204895240294;
    try {
      btn.disabled = true;
      const realFetch = window.__crncyRealFetch || window.fetch;
      await realFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: VARIANT_ID, quantity: 1 })
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error(err);
    } finally {
      btn.disabled = false;
    }
  });

  // ── CRNCY Name Pendant: variant selection + per-letter pricing ────────────

  var _crncyVariants = [];
  var _crncyVariantsLoaded = false;
  var _crncyCurrentUpdate = null;

  function buildVariantListFromConfig(variants) {
    _crncyVariants = variants.map(function(v) {
      return {
        id: v.id,
        price: v.price,
        options: [v.option1, v.option2, v.option3].filter(function(o) { return o !== null && o !== undefined; })
      };
    });
    _crncyVariantsLoaded = true;
  }

  // Mirror the upsell snippet's refreshCart: swap only the items holder and
  // price holder, preserving all custom cart drawer blocks (VIP, savings, etc.)
  function pendantRefreshCart() {
    var realFetch = window.__crncyRealFetch || window.fetch;
    return realFetch('/?sections=cart-drawer')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Swap items
        var newItems = doc.querySelector('[data-items-holder]');
        var oldItems = document.querySelector('[data-items-holder]');
        if (newItems && oldItems && oldItems.parentNode) {
          oldItems.parentNode.replaceChild(newItems.cloneNode(true), oldItems);
        }
        // Swap price
        var newPrice = doc.querySelector('[data-cart-price-holder]');
        var oldPrice = document.querySelector('[data-cart-price-holder]');
        if (newPrice && oldPrice) oldPrice.innerHTML = newPrice.innerHTML;
        // Remove empty state
        var cd = document.querySelector('cart-drawer');
        if (cd) cd.classList.remove('is-empty');
        // Update count badge
        return realFetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function(el) {
            el.textContent = cart.item_count;
            el.setAttribute('data-cart-count', cart.item_count);
          });
        });
      });
  }

  function openCartDrawer() {
    var toggle = document.querySelector('[data-cart-toggle]');
    if (toggle) {
      toggle.click();
      return;
    }
    document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
  }

  function initPendantPricing() {
    var configEl = document.querySelector('[id^="crncy-pendant-config-"]');
    if (!configEl) return;

    var config;
    try { config = JSON.parse(configEl.textContent); } catch(e) { return; }

    var sectionId        = config.sectionId;
    var czPrice          = config.czPrice          || 0;
    var moisPrice        = config.moisPrice        || 0;
    var czComparePrice   = config.czComparePrice   || 0;
    var moisComparePrice = config.moisComparePrice || 0;
    var minLetters       = config.minLetters       || 0;
    var maxLetters       = config.maxLetters       || 0;
    var hasStoneType     = config.hasStoneType !== false;

    if (config.variants) {
      buildVariantListFromConfig(config.variants);
    }

    var textInput   = document.getElementById('crncy-customization-input-' + sectionId);
    var stoneLabel  = document.getElementById('crncy-stone-selected-' + sectionId);
    var letterCount = document.getElementById('crncy-letters-count-' + sectionId);
    var letterHint  = document.getElementById('crncy-letter-hint-' + sectionId);
    var atcBtn      = document.getElementById('ProductSubmitButton-' + sectionId);
    var productForm = document.querySelector('product-form');

    if (!textInput || !atcBtn || !productForm) return;

    var atcBtnText = atcBtn.querySelector('.btn__text');

    function formatMoney(cents) {
      var dollars = cents / 100;
      return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
    }

    function getColor() {
      var checked = document.querySelector('input.crncy-color-input:not([name^="properties"]):checked');
      if (checked) return checked.value;
      try {
        var sv = JSON.parse(document.querySelector('[data-selected-variant]').textContent);
        return sv.option1 || 'Gold';
      } catch(e) { return 'Gold'; }
    }

    function getStone() {
      if (!hasStoneType) return null;
      var checked = document.querySelector('input[name="properties[Stone Type]"]:checked');
      return checked ? checked.value : null;
    }

    function getLetterCount() {
      return textInput.value.replace(/\s/g, '').length;
    }

    function isValid() {
      var letters = getLetterCount();
      return letters > 0 && !(minLetters > 0 && letters < minLetters);
    }

    function isMoissanite() {
      var stone = getStone();
      return stone && /moissanite/i.test(stone);
    }

    function getDefaultPriceCents() {
      return (isMoissanite() ? moisPrice : czPrice) * 100;
    }

    function getComparePriceCents(letters) {
      var perLetter = isMoissanite() ? moisComparePrice : czComparePrice;
      if (!perLetter) return 0;
      var count = letters > 0 ? letters : (minLetters || 1);
      return perLetter * count * 100;
    }

    function getExtraOptionValues() {
      var extras = [];
      var radios = document.querySelectorAll(
        'variant-selects input[type="radio"]:checked, ' +
        'variant-radios input[type="radio"]:checked, ' +
        'variant-selects select option:checked, ' +
        'variant-radios select option:checked'
      );
      radios.forEach(function(el) {
        var name = el.name || (el.parentElement && el.parentElement.name) || '';
        var val = el.value;
        if (!val) return;
        if (/color/i.test(name)) return;
        if (/stone/i.test(name)) return;
        if (/letter/i.test(name)) return;
        extras.push(val);
      });
      return extras;
    }

    function findVariant(color, stone, letters) {
      var lettersStr = String(letters);
      var required = [color, lettersStr];
      if (stone) required.push(stone);
      var extras = getExtraOptionValues();
      extras.forEach(function(v) { required.push(v); });

      for (var i = 0; i < _crncyVariants.length; i++) {
        var v = _crncyVariants[i];
        var allMatch = required.every(function(r) {
          return v.options.indexOf(r) !== -1;
        });
        if (allMatch) return v;
      }
      return null;
    }

    function selectVariantAndGetPrice() {
      var letters = getLetterCount();
      if (letters === 0) return null;
      var color = getColor();
      var stone = getStone();
      var match = findVariant(color, stone, letters);
      if (!match) return null;
      document.querySelectorAll('input[name="id"]').forEach(function(inp) {
        inp.value = match.id;
      });
      return match.price;
    }

    function updatePriceDisplay(currentCents, compareCents) {
      var saleEl     = document.querySelector('.price-item--sale');
      var regularEls = document.querySelectorAll('.price-item--regular');
      var hasSaleVisible = saleEl && saleEl.offsetParent !== null;
      var showCompare = compareCents && compareCents > currentCents;

      if (hasSaleVisible) {
        saleEl.textContent = formatMoney(currentCents);
        regularEls.forEach(function(el) {
          el.textContent = formatMoney(showCompare ? compareCents : currentCents);
        });
      } else {
        regularEls.forEach(function(el) {
          el.textContent = formatMoney(currentCents);
          if (showCompare) {
            el.style.color = 'var(--COLOR-SALE,#c8102e)';
          } else {
            el.style.color = '';
          }
        });
        injectOrUpdateSyntheticCompare(showCompare ? compareCents : 0);
      }
    }

    function injectOrUpdateSyntheticCompare(compareCents) {
      var existing = document.querySelector('.crncy-synthetic-compare');
      if (!compareCents) {
        if (existing) existing.remove();
        return;
      }
      if (existing) {
        existing.textContent = formatMoney(compareCents);
        return;
      }
      var anchor = document.querySelector('.price-item--regular');
      if (!anchor) return;
      var span = document.createElement('span');
      span.className = 'crncy-synthetic-compare';
      span.style.cssText = 'text-decoration:line-through;margin-right:8px;font-weight:normal;opacity:0.55;';
      span.textContent = formatMoney(compareCents);
      anchor.parentNode.insertBefore(span, anchor);
    }

    function updatePrice() {
      var letters = getLetterCount();
      var priceCents = selectVariantAndGetPrice();
      var displayCents = priceCents || getDefaultPriceCents();
      var compareCents = getComparePriceCents(letters);

      if (letterCount) {
        letterCount.textContent = letters > 0
          ? letters + (letters === 1 ? ' letter' : ' letters')
          : (minLetters > 0 && maxLetters > 0 ? minLetters + '\u2013' + maxLetters + ' letters' : 'Enter your text');
      }

      var valid = isValid();
      if (letterHint) {
        if (letters > 0 && !valid) {
          letterHint.textContent = 'Minimum ' + minLetters + ' letter' + (minLetters === 1 ? '' : 's') + ' required';
          letterHint.classList.add('crncy-hint-error');
          textInput.classList.add('crncy-input-error');
        } else {
          letterHint.classList.remove('crncy-hint-error');
          textInput.classList.remove('crncy-input-error');
        }
      }

      updatePriceDisplay(displayCents, compareCents);

      if (atcBtnText) {
        var t = atcBtnText.textContent.trim();
        if (t !== 'Add to cart' && t !== 'Adding...' && /\$[\d]/.test(t)) {
          atcBtnText.textContent = 'Add to cart';
        }
      }

      // Announce the result to screen readers (price, or why ATC is disabled).
      if (letters > 0 && valid) {
        crncyAnnounce('Price: ' + formatMoney(displayCents));
      } else if (letters > 0 && !valid) {
        crncyAnnounce('Minimum ' + minLetters + ' letter' + (minLetters === 1 ? '' : 's') + ' required');
      }

      atcBtn.disabled = !(letters > 0 && valid);
    }

    _crncyCurrentUpdate = updatePrice;

    var priceElsToObserve = document.querySelectorAll('.price-item--regular, .price-item--sale');
    priceElsToObserve.forEach(function(priceEl) {
      if (priceEl.dataset.crncyObserved) return;
      priceEl.dataset.crncyObserved = '1';
      new MutationObserver(function() {
        var text = priceEl.textContent.trim();
        if (text && /\$[\d,]+\.\d{2}/.test(text)) {
          var cents = Math.round(parseFloat(text.replace(/[^0-9.]/g, '')) * 100);
          if (cents > 0) priceEl.textContent = formatMoney(cents);
        }
      }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    });

    if (atcBtnText && !atcBtnText.dataset.crncyObserved) {
      atcBtnText.dataset.crncyObserved = '1';
      new MutationObserver(function() {
        var text = atcBtnText.textContent.trim();
        if (text && text !== 'Add to cart' && text !== 'Adding...' && /\$[\d]/.test(text)) {
          atcBtnText.textContent = 'Add to cart';
        }
      }).observe(atcBtnText, { childList: true, characterData: true, subtree: true });
    }

    if (!productForm.dataset.crncyBound) {
      productForm.dataset.crncyBound = '1';

      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!isValid()) return;
        var priceCents = selectVariantAndGetPrice();
        if (!priceCents) return;
        var variantIdInput = document.querySelector('input[name="id"]');
        if (!variantIdInput) return;
        var variantId = parseInt(variantIdInput.value);
        var customizationValue = textInput.value.trim();
        var properties = { 'Customization': customizationValue };
        if (hasStoneType) properties['Stone Type'] = getStone();
        atcBtn.disabled = true;
        if (atcBtnText) atcBtnText.textContent = 'Adding...';

        var realFetch = window.__crncyRealFetch || window.fetch;
        realFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          if (atcBtnText) atcBtnText.textContent = 'Add to cart';
          atcBtn.disabled = false;
          // Use the same section-render swap the upsell snippet uses:
          // only replaces [data-items-holder] and [data-cart-price-holder],
          // preserving all custom cart drawer blocks.
          return pendantRefreshCart();
        })
        .then(function() {
          openCartDrawer();
          updatePrice();
        })
        .catch(function(err) {
          console.error('Cart add error:', err);
          if (atcBtnText) atcBtnText.textContent = 'Add to cart';
          atcBtn.disabled = false;
          updatePrice();
        });
      }, true);

      if (hasStoneType) {
        document.querySelectorAll('input[name="properties[Stone Type]"]').forEach(function(input) {
          input.addEventListener('change', function() {
            if (stoneLabel) stoneLabel.textContent = this.value;
            updatePrice();
          });
        });
      }

      textInput.addEventListener('input', updatePrice);
    }

    document.querySelectorAll('input.crncy-color-input').forEach(function(input) {
      if (input.dataset.crncyColorBound !== '1') {
        input.dataset.crncyColorBound = '1';
        input.addEventListener('change', function() {
          updatePrice();
          setTimeout(updatePrice, 50);
        });
      }
    });

    document.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"], variant-selects select, variant-radios select').forEach(function(input) {
      if (input.dataset.crncyExtraBound === '1') return;
      input.dataset.crncyExtraBound = '1';
      input.addEventListener('change', function() {
        updatePrice();
        setTimeout(updatePrice, 50);
      });
    });

    updatePrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPendantPricing);
  } else {
    initPendantPricing();
  }

  if (typeof subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
    subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function() {
      if (typeof _crncyCurrentUpdate === 'function') _crncyCurrentUpdate();
      setTimeout(function() {
        if (typeof _crncyCurrentUpdate === 'function') _crncyCurrentUpdate();
      }, 50);
      setTimeout(initPendantPricing, 200);
      setTimeout(initPendantPricing, 600);
    });
  }

  // ── CRNCY accessibility: photo upload widget dialogs ──────────────────────
  // Additive layer for the Cloudinary upload blocks (single #crncy* and dual
  // #crncy2*). Adds dialog semantics, focus trap + return, Escape-to-close,
  // spoken status, an announced "upload both photos" gate, and keyboard-
  // operable recent thumbnails — WITHOUT modifying the widgets' own
  // upload / crop / cart code. No-ops on pages where the widgets aren't present.
  (function initUploadA11y() {
    function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
    var SR_ONLY = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0;';

    ready(function() {
      // Remember the last control the user activated, so focus returns there
      // after the native file picker (which steals focus) closes.
      var lastTrigger = null;
      document.addEventListener('click', function(e){
        var t = e.target.closest(
          '.crncy-upload-tile, .crncy2-tile, .crncy-recent-item, .crncy2-recent-item, ' +
          '.crncy-crop-switch, .crncy2-crop-switch, .crncy-preview-link, .crncy2-preview-link'
        );
        if (t) lastTrigger = t;
      }, true);

      function focusables(container){
        var sel = 'button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
        return Array.prototype.filter.call(container.querySelectorAll(sel), function(el){
          return el.offsetParent !== null;
        });
      }

      function makeDialog(overlay, opts) {
        if (!overlay || overlay.__a11yWired) return;
        overlay.__a11yWired = true;
        var box = opts.box || overlay;
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        box.setAttribute('tabindex', '-1');
        if (opts.labelEl) {
          if (!opts.labelEl.id) opts.labelEl.id = opts.labelId;
          box.setAttribute('aria-labelledby', opts.labelEl.id);
        } else if (opts.ariaLabel) {
          box.setAttribute('aria-label', opts.ariaLabel);
        }
        if (opts.describeText) {
          var d = document.createElement('p');
          d.id = (opts.labelId || 'crncy-dlg') + '-desc';
          d.style.cssText = SR_ONLY;
          d.textContent = opts.describeText;
          box.appendChild(d);
          box.setAttribute('aria-describedby', d.id);
        }

        var returnTo = null;
        function onKey(e){
          if (e.key === 'Escape') { e.preventDefault(); opts.onEscape(); return; }
          if (e.key !== 'Tab') return;
          var f = focusables(overlay);
          if (!f.length) { e.preventDefault(); box.focus(); return; }
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && (document.activeElement === first || document.activeElement === box)) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
        new MutationObserver(function(){
          var active = overlay.classList.contains('active');
          if (active && !overlay.__open) {
            overlay.__open = true;
            returnTo = (lastTrigger && document.body.contains(lastTrigger)) ? lastTrigger
                     : (document.activeElement && document.activeElement !== document.body ? document.activeElement : null);
            overlay.addEventListener('keydown', onKey);
            setTimeout(function(){
              var tgt = (opts.focusTarget && opts.focusTarget()) || box;
              if (tgt && tgt.focus) tgt.focus();
            }, 40);
          } else if (!active && overlay.__open) {
            overlay.__open = false;
            overlay.removeEventListener('keydown', onKey);
            if (returnTo && returnTo.focus && document.body.contains(returnTo)) returnTo.focus();
          }
        }).observe(overlay, { attributes: true, attributeFilter: ['class'] });
      }

      function liveify(el, assertive){
        if (!el || el.__live) return;
        el.__live = true;
        el.setAttribute('role', assertive ? 'alert' : 'status');
        el.setAttribute('aria-live', assertive ? 'assertive' : 'polite');
        el.setAttribute('aria-atomic', 'true');
      }

      function labelByText(el, label){ if (el && !el.getAttribute('aria-label')) el.setAttribute('aria-label', label); }

      function keyboardThumbs(rowSelector, itemSelector){
        document.addEventListener('keydown', function(e){
          if (e.key !== 'Enter' && e.key !== ' ') return;
          var item = e.target.closest(itemSelector);
          if (!item) return;
          e.preventDefault(); item.click();
        });
        function tag(){
          document.querySelectorAll(itemSelector).forEach(function(it){
            if (!it.hasAttribute('tabindex')) it.setAttribute('tabindex', '0');
            if (!it.hasAttribute('role')) it.setAttribute('role', 'button');
            if (!it.getAttribute('aria-label')) it.setAttribute('aria-label', 'Use this recent photo');
          });
        }
        tag();
        var row = document.querySelector(rowSelector);
        if (row) new MutationObserver(tag).observe(row, { childList: true, subtree: true });
      }

      var CROP_HELP = 'Drag the image or use the zoom slider to frame your photo. Framing is optional — our team reviews every photo before production.';

      // ── Single-photo widget ──
      var sCrop = document.getElementById('crncyCropOverlay');
      if (sCrop) {
        var sBox = sCrop.querySelector('.crncy-crop-box');
        var sCancel = document.getElementById('crncyCancel');
        makeDialog(sCrop, {
          box: sBox,
          labelEl: sCrop.querySelector('.crncy-crop-title'), labelId: 'crncyCropTitle',
          describeText: CROP_HELP,
          focusTarget: function(){ return sBox; },
          onEscape: function(){ if (sCancel) sCancel.click(); }
        });
        labelByText(document.getElementById('crncyZoom'), 'Zoom');
        liveify(document.getElementById('crncyStatus'), false);
        keyboardThumbs('#crncyRecentRow', '.crncy-recent-item');
      }
      var sPrev = document.getElementById('crncyPreviewOverlay');
      if (sPrev) {
        var sClose = document.getElementById('crncyPreviewClose');
        labelByText(sClose, 'Close preview');
        makeDialog(sPrev, { ariaLabel: 'Photo preview', focusTarget: function(){ return sClose; }, onEscape: function(){ if (sClose) sClose.click(); } });
      }

      // ── Dual-photo widget ──
      var dCrop = document.getElementById('crncy2CropOverlay');
      if (dCrop) {
        var dBox = dCrop.querySelector('.crncy2-crop-box');
        var dCancel = document.getElementById('crncy2Cancel');
        makeDialog(dCrop, {
          box: dBox,
          labelEl: document.getElementById('crncy2CropTitle'), labelId: 'crncy2CropTitle',
          describeText: CROP_HELP,
          focusTarget: function(){ return dBox; },
          onEscape: function(){ if (dCancel) dCancel.click(); }
        });
        labelByText(document.getElementById('crncy2Zoom'), 'Zoom');
        document.querySelectorAll('.crncy2-status[data-status]').forEach(function(s){ liveify(s, false); });
        keyboardThumbs('#crncy2RecentRow', '.crncy2-recent-item');

        // Gate: announce "upload both photos" and keep the Add to Cart button's
        // disabled state exposed to assistive tech, mirroring the visual class.
        var gate = document.getElementById('crncy2GateMsg');
        if (gate) {
          liveify(gate, true);
          new MutationObserver(function(){
            if (gate.classList.contains('active')) {
              var msg = gate.textContent;
              gate.textContent = '';
              setTimeout(function(){ gate.textContent = msg; }, 30);
            }
          }).observe(gate, { attributes: true, attributeFilter: ['class'] });

          setInterval(function(){
            document.querySelectorAll(
              'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"], .product-form__submit, [data-quick-add-btn]'
            ).forEach(function(btn){
              if (btn.closest('.crncy-upsell, [class*="upsell"]')) return;
              var off = btn.classList.contains('crncy2-atc-disabled');
              if (off && btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
              if (!off && btn.getAttribute('aria-disabled') === 'true') btn.removeAttribute('aria-disabled');
            });
          }, 400);
        }
      }
      var dPrev = document.getElementById('crncy2PreviewOverlay');
      if (dPrev) {
        var dClose = document.getElementById('crncy2PreviewClose');
        labelByText(dClose, 'Close preview');
        makeDialog(dPrev, { ariaLabel: 'Photo preview', focusTarget: function(){ return dClose; }, onEscape: function(){ if (dClose) dClose.click(); } });
      }
    });
  })();

  // ── CRNCY accessibility: cart change announcements ────────────────────────
  // Speaks "Added to cart" / "Item removed" when the cart count changes, via the
  // shared live region. Works regardless of which code path updates the cart
  // (pendant add, remove button, quantity steppers, upsell).
  (function initCartAnnounce() {
    function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
    ready(function() {
      var counter = document.querySelector('[data-cart-count]');
      if (!counter) return;
      function readCount(){
        var attr = counter.getAttribute('data-cart-count');
        var n = parseInt(attr != null ? attr : counter.textContent, 10);
        return isNaN(n) ? null : n;
      }
      function plural(n){ return n + (n === 1 ? ' item' : ' items'); }
      var last = readCount();
      var t = null;
      function check(){
        var n = readCount();
        if (n === null || n === last) return;
        var up = (last === null) || (n > last);
        last = n;
        clearTimeout(t);
        t = setTimeout(function(){
          if (n === 0) crncyAnnounce('Your cart is empty');
          else if (up) crncyAnnounce('Added to cart. ' + plural(n) + ' in cart.');
          else crncyAnnounce('Item removed. ' + plural(n) + ' in cart.');
        }, 150);
      }
      new MutationObserver(check).observe(counter, {
        childList: true, characterData: true, subtree: true,
        attributes: true, attributeFilter: ['data-cart-count']
      });
    });
  })();

  // ── CRNCY accessibility: Add-to-Cart button name ─────────────────────────
  // The Pill ATC override hides the real button text and paints the label with
  // a CSS ::before, which screen readers can't read (button has no accessible
  // name). This gives the button a real aria-label and keeps it in sync with
  // the override's data-crncy-* state attributes. Does not touch the override.
  (function initAtcLabel() {
    function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
    function labelFor(btn){
      if (btn.hasAttribute('data-crncy-soldout')) return 'Sold out';
      if (btn.hasAttribute('data-crncy-loading')) return 'Adding to cart';
      if (btn.hasAttribute('data-crncy-success')) return 'Added to cart';
      return 'Add to cart';
    }
    function wire(btn){
      if (!btn || btn.__crncyLabelWired) return;
      if (btn.closest('.crncy-upsell, [class*="upsell"]')) return;
      var f = btn.closest('form');
      if (f && f.id && /upsell|quick-add|api-product-upsell/i.test(f.id)) return;
      btn.__crncyLabelWired = true;
      btn.setAttribute('aria-label', labelFor(btn));
      new MutationObserver(function(){ btn.setAttribute('aria-label', labelFor(btn)); })
        .observe(btn, { attributes: true, attributeFilter: ['data-crncy-soldout', 'data-crncy-loading', 'data-crncy-success'] });
    }
    function scan(){ document.querySelectorAll('button[type="submit"][name="add"], .product-form__submit').forEach(wire); }
    ready(function(){
      scan();
      [300, 1200].forEach(function(ms){ setTimeout(scan, ms); });
      ['variant:change', 'on:variant:change'].forEach(function(evt){ document.addEventListener(evt, scan); });
    });
  })();

  // ── CRNCY accessibility: upsell carousel arrow names ─────────────────────
  // The chain-upsell carousel arrows (.carousel-button.left/.right) render with
  // no text and no aria-label, so screen readers announce them as unnamed
  // buttons. This labels them additively. It survives an upsell rebuild as long
  // as the arrows keep the .carousel-button + .left/.right classes; if you
  // rename them during the rebuild, update the selector below.
  (function initCarouselArrowLabels() {
    function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
    function label(btn){
      if (!btn || btn.__crncyArrowLabeled) return;
      if (btn.getAttribute('aria-label') || (btn.textContent || '').trim()) { btn.__crncyArrowLabeled = true; return; }
      if (btn.classList.contains('left')) { btn.setAttribute('aria-label', 'Previous'); btn.__crncyArrowLabeled = true; }
      else if (btn.classList.contains('right')) { btn.setAttribute('aria-label', 'Next'); btn.__crncyArrowLabeled = true; }
    }
    function scan(){ document.querySelectorAll('button.carousel-button').forEach(label); }
    ready(function(){
      scan();
      [400, 1500].forEach(function(ms){ setTimeout(scan, ms); });
      new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i++) {
          var nodes = muts[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('button.carousel-button')) label(n);
            if (n.querySelectorAll) n.querySelectorAll('button.carousel-button').forEach(label);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();